export default __webpack_public_path__ + "static/media/logo.c0d28ea7.png";